var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 11,
  viewBox: "0 0 18 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.1399 0.468011L8.93188 6.67601L2.72388 0.468011C2.09988 -0.15599 1.09188 -0.15599 0.467882 0.468011C-0.156116 1.09201 -0.156116 2.10001 0.467882 2.72401L7.81188 10.068C8.43588 10.692 9.44388 10.692 10.0679 10.068L17.4119 2.72401C18.0359 2.10001 18.0359 1.09201 17.4119 0.468011C16.7879 -0.13999 15.7639 -0.15599 15.1399 0.468011Z",
  fill: "white"
})));
export default SvgDownArrow;